import { render, staticRenderFns } from "./EcologySoilHealthForm.vue?vue&type=template&id=33ef4c63&scoped=true&lang=html&"
import script from "./EcologySoilHealthForm.vue?vue&type=script&lang=js&"
export * from "./EcologySoilHealthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef4c63",
  null
  
)

export default component.exports